import { Repeater, DOMFactory, AutocompleteService } from "./interfaces";

export class RepeaterController implements Repeater {
    constructor(
        private domFactory: DOMFactory,
        private autocompleteService: AutocompleteService
    ) {}

    prepareItem( buttonContainer: HTMLButtonElement, value: string): void {
        let newLocationField: HTMLInputElement;
        if (value) {
            newLocationField = this.domFactory.createInputWithValue(value);
        } else {
            newLocationField = this.domFactory.createInput();
        }

        const inputContainer = this.domFactory.createInputContainer();
        const removeButton = this.domFactory.createRemoveButton();
        inputContainer.appendChild(newLocationField);
        inputContainer.appendChild(removeButton);

        buttonContainer.parentNode?.insertBefore( inputContainer, buttonContainer );

        this.autocompleteService.attachAutocomplete(newLocationField);
        this.removeItem(removeButton);
    }

    addItem(): void {
        const repeaterButtonContainer = document.querySelector<HTMLButtonElement>('.js-jobtek-add-location');
        if ( !repeaterButtonContainer) {
            console.warn('Repeater button container not found');
            return;
        }

        const repeaterButton = this.domFactory.getButton();

        if (!repeaterButton) {
            console.warn('Repeater button not found');
            return;
        }

        repeaterButton.addEventListener('click', () => {
            this.prepareItem(repeaterButtonContainer, '');
        });
    }

    generateItems( buttonContainer: HTMLButtonElement, locations: [] ) {
        if ( !locations || locations.length === 0 ) {
            return;
        }
        
        locations.forEach( (location) => {
            this.prepareItem(buttonContainer, location as string);
        });
    }

    removeItem(button: HTMLButtonElement): void {
        if (!button) {
            console.warn('Remove button not found');
            return;
        }

        button.addEventListener('click', () => {
            const inputContainer = button.closest('.jobtek-multi-location-field-container');
            if (inputContainer) {
                inputContainer.remove();
            } else {
                console.warn('Input container not found for remove button');
            }
        });
    }
}